export enum RoutePaths {
  home = '/',
  componentsCheck = '/components-check',
  portioningDisplay = '/portioning',
  mealsStatus = '/meals',
  wastageTracking = '/wastage-tracking',
  qualityTracking = '/quality-tracking',
  shortageReporting = '/shortage-reporting',
  shortageDisplay = '/shortage-display',
  assemblyCheck = '/assembly-check',
  preDispatchCheck = '/predispatch-check',
  recipeGuideBook = '/recipe-guide-book',
  lockTimeChanges = '/lock-time-changes',
  logisticsChanges = '/logistics-changes',
  driverDispatch = '/driver-dispatch',
  customerComplaints = '/customer-complaints',
  fileManagement = '/file-management',
  specialRequest = '/special-request',
  qualityMetrics = '/quality-metrics',
  productivityMetrics = '/productivity-metrics',
  leftoverMetrics = '/leftoverMetrics',
  componentsPortioning = '/componentsPortioning',
  yieldTracking = '/yieldTracking',
  kitchenStaff = '/kitchen-staff',
  staffTracking = '/labor-planning',
  productionControl = '/production-control',
  foodPortioningRecord = '/food-portioning-record',
  topControl = '/top-control',
  controlTower = '/control-tower',
  productionPlan = '/production-plan',
  weightTracking = '/metrics-yield-tracking',
  batchTracking = '/batch-tracking',
  batchTrackingBatch = '/batch-tracking/batches/:batchId',
  batchTrackingAccounts = '/batch-tracking/accounts',
  videoReview = '/review'
}

export enum FoodComponentStationTitle {
  commissary = 'Commissary',
  butchery = 'Butchery',
  boiling = 'Boiling',
  hotBakery = 'Hot Bakery',
  coldPastry = 'Cold Pastry',
  assembly = 'Assembly',
  coldSauce = 'Cold Sauce',
  hot = 'Hot',
  bakeryAndPastry = 'Bakery & Pastry',
  saucier = 'Saucier',
  roasting = 'Roasting',
  gardeManger = 'Garde Manger',
  portioning = 'Portioning',
  merchandise = 'Merchandise',
  other = 'Other'
}

export enum LeftoverAction {
  waste = 'Waste',
  useTomorrow = 'Use tomorrow',
  staffMeal = 'Staff meal',
  other = 'Other'
}

export enum PreDispatchCheckHeader {
  breakfast = 'Breakfast',
  lunchAndDinner = 'Lunch & Dinner',
  snack = 'Snack',
  addons = 'Add ons',
  dessert = 'Dessert',
  caloKids = 'Calo Kids'
}

export enum Shift {
  // earlyMorning = 'Early Morning Shift',
  morning = 'Morning Shift',
  evening = 'Evening Shift',
  all = 'All Shifts'
}

export enum Actions {
  noActionTaken = 'No Action Taken',
  continueChilling = 'Continue Chilling',
  discard = 'Discard',
  employeeRetraining = 'Employee Retraining',
  equipmentMaintenance = 'Equipment Maintenance'
}

export enum WastageActions {
  noActionTaken = 'No Action Taken',
  waste = 'Waste',
  useTomorrow = 'Use Tomorrow',
  staffMeal = 'Staff Meal',
  other = 'Other'
}

export enum Page {
  assemblyCheck = 'assemblyCheck',
  portioningDisplay = 'portioningDisplay',
  foodPortioningRecord = 'foodPortioningRecord'
}

export enum FoodPortioningStatus {
  notReadyYet = 'Not ready yet',
  readyToAssemble = 'Ready to assemble',
  pauseAssembling = 'Pause Assembling',
  resumeAssembling = 'Resume Assembling',
  readyToPortion = 'Ready to portion',
  pausePortioning = 'Pause Portioning',
  resumePortioning = 'Resume Portioning',
  Assembling = 'Assembling',
  Portioning = 'Portioning',
  completed = 'Completed'
}

export enum FoodPortioningAction {
  pending = 'Pending',
  startAssembling = 'Start Assembling',
  pauseAssembling = 'Pause Assembling',
  resumeAssembling = 'Resume Assembling',
  finishAssembling = 'Finish Assembling',
  pausePortioning = 'Pause Portioning',
  resumePortioning = 'Resume Portioning',
  startPortioning = 'Start Portioning',
  finishPortioning = 'Finish Portioning',
  completed = 'Completed'
}

export enum FoodPortioningFoodType {
  notReadyFood = 'notReadyFood',
  startAssemblingFood = 'startAssemblingFood',
  pauseAssemblingFood = 'pauseAssemblingFood',
  resumeAssemblingFood = 'resumeAssemblingFood',
  startPortioningFood = 'startPortioningFood',
  pausePortioningFood = 'pausePortioningFood',
  resumePortioningFood = 'resumePortioningFood',
  completedFood = 'completedFood'
}

export enum NotificationType {
  lockTimeChange = 'Locktime Change',
  logisticsChange = 'Logistics Change',
  shortage = 'Shortage'
}

export enum ComplaintReason {
  HEALTH_RELATED_CONCERNS_COMPLAINTS = 'Health Related Concerns',
  COLD_SECTION_RELATED_ERRORS = 'Cold Section Related Errors',
  SPILLED_LIQUIDS_OR_FOOD_COMPLAINTS = 'Spilled Liquids or Food',
  DISPATCH_RELATED_ERRORS = 'Dispatch Related Errors',
  QUALITY_RELATED_COMPLAINTS = 'Quality Related Errors',
  FOREIGN_OBJECTS_FOUND = 'Foreign Objects Found',
  FOOD_RELATED_FOREIGN_OBJECTS_FOUND = 'Food Related Foreign Objects',
  NON_FOOD_RELATED_FOREIGN_OBJECTS_FOUND = 'Non-Food Related Foreign Objects'
}

export enum FileManagementType {
  meal = 'meals',
  customer = 'customer'
}

export enum DriverDispatchType {
  caloDrivers = 'caloDrivers',
  others = 'others'
}

export enum ExportMetricsType {
  meals = 'meals',
  components = 'components'
}

export enum LeftoverMetricsViewTypes {
  meals = 'meals',
  components = 'components'
}

export enum KDSPermission {
  VIEW_COMPONENTS_CHECK = 'v:cc',
  VIEW_PORTIONING_DISPLAY = 'v:pd',
  VIEW_MEALS_STATUS = 'v:ms',
  VIEW_WASTAGE_TRACKING = 'v:wt',
  VIEW_QUALITY_TRACKING = 'v:qt',
  VIEW_SHORTAGE_REPORTING = 'v:sr',
  VIEW_SHORTAGE_DISPLAY = 'v:sd',
  VIEW_ASSEMBLY_CHECK = 'v:ac',
  VIEW_PRE_DISPATCH_CHECK = 'v:pdc',
  VIEW_RECIPE_GUIDEBOOK = 'v:rg',
  VIEW_LOCK_TIME_CHANGES = 'v:ltc',
  VIEW_LOGISTICS_CHANGES = 'v:lc',
  VIEW_DRIVER_DISPATCH = 'v:dd',
  VIEW_CUSTOMER_COMPLAINTS = 'v:ccm',
  VIEW_FILE_MANAGEMENT = 'v:fm',
  VIEW_SPECIAL_REQUEST = 'v:srq',
  VIEW_QUALITY_METRICS = 'v:qm',
  VIEW_PRODUCTIVITY_METRICS = 'v:pm',
  VIEW_LEFTOVER_METRICS = 'v:lm',
  VIEW_COMPONENTS_PORTIONING = 'v:cp',
  VIEW_KITCHEN_STAFF = 'v:ks',
  VIEW_YIELD_TRACKING = 'v:yt',
  VIEW_WEIGHT_TRACKING = 'v:wtr',
  VIEW_LABOR_PLANNING = 'v:lp',
  VIEW_PRODUCTION_CONTROL = 'v:prc',
  VIEW_TOP_CONTROL = 'v:tc',
  EDIT_PRODUCTION_CONTROL = 'e:prc',
  VIEW_KITCHEN_FLOOR = 'v:kf',
  VIEW_PRODUCTION_PLAN = 'v:pp',
  APPROVE_PLANNER_ACTIONS = 'a:pa',
  EDIT_BUFFER = 'e:bf',
  VIEW_BATCH_TRACKING = 'v:bt',
  EDIT_BATCH_TRACKING_VOID = 'e:tv',
  HEAD_CHEF = 'e:hc',
  VERIFY_COMPONENTS = 'e:vc',
  EXPORT_DATA = 'e:ex',
  VIEW_COSTS = 'v:co'
}

export enum AuthState {
  loading = 'loading',
  signedIn = 'signedIn',
  signIn = 'signIn'
}

export enum ChallengeType {
  OTP = 'OTP',
  RESEND_OTP = 'RESEND_OTP'
}

export enum ProcessTimeWarningStatus {
  warning = 'warning',
  danger = 'danger'
}

export enum PortioningTabs {
  regular = 0,
  modified = 1,
  athlete = 2,
  mcm = 3,
  kids = 4,
  addons = 5,
  cafe = 6
}

export enum PortioningTabsLabels {
  regular = 'Regular',
  modified = 'Modified',
  athlete = 'Athlete',
  mcm = 'MCM',
  kids = 'Kids',
  addons = 'Add-ons',
  cafe = 'Cafe'
}
